<!-- <span class="loader" [class]="classes" #spinner></span> -->
<seech-shared-spinner [color]="color" [size]="size" [strokeWidth]="strokeWidth"></seech-shared-spinner>
